import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {TaskSidebarItem} from "@shared/ag-task/ag-task.component.ds";
import {FeatureComponentMode} from "@core/enums/core.enums";
import {ClientPortalUser} from "@data/interefaces/client-portal.interfaces";
import {ActivatedRoute} from "@angular/router";
import {BaseComponent} from "@pages/base.component";

@Component({
  selector: 'app-user-list-task',
  templateUrl: './user-list-task.component.html',
  styleUrls: ['./user-list-task.component.scss']
})
export class UserListTaskComponent extends BaseComponent implements AfterViewInit {
  featureComponentSidebarEl: TaskSidebarItem[] = [
    {
      title: "Bulk License / Un-license",
      icon: "fa-id-card",
      selected: true,
      urlSupport: false,
      disabled: false,
      mode: FeatureComponentMode.BULK_LICENSE
    }
  ];
  @Input() selectedFeatureMode: FeatureComponentMode | undefined;
  @Input() selectedRows!: ClientPortalUser[];
  @Output() goBackEvent: EventEmitter<any> = new EventEmitter<any>();
  protected readonly FeatureComponentMode = FeatureComponentMode;

  isUrlMode: boolean = false;
  urlModeGoBackUrl: string = "/";

  constructor(protected _activatedRoute: ActivatedRoute) {
    super();
    let paramMode = this._activatedRoute.snapshot.params['mode'];
    if (paramMode) {
      this.isUrlMode = true;
      this.selectedFeatureMode = paramMode;
    }
  }

  ngAfterViewInit(): void {
  }

}
